import React, { useEffect, useState } from "react";
import { Upload, Form, Button } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { IMAGE_BASE_PATH } from "../../utils/constant";

const getBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

const FormAntdUploadBase64 = ({
  label,
  name,
  rules,
  listType = "picture",
  maxCount,
  form,
}) => {
  const [fileList, setFileList] = useState([]);

  useEffect(() => {
    const media = form.getFieldValue(name);
    if (media && media.length > 0) {
      const existingFiles = media.map((item, index) => ({
        uid: `-${index + 1}`,
        name: item.media || `image-${index + 1}.png`,
        status: "done",
        url: `${IMAGE_BASE_PATH}${item.media}`,
        ...item,
      }));
      setFileList(existingFiles);
    }
  }, [form, name]);

  const handleChange = async ({ fileList: newFileList }) => {
    const processedFiles = await Promise.all(
      newFileList.map(async (file) => {
        if (!file.url && !file.base64 && file.originFileObj) {
          const base64 = await getBase64(file.originFileObj);
          return { ...file, base64 };
        }
        return file;
      })
    );

    setFileList(processedFiles);
    form.setFieldsValue({ [name]: processedFiles });
  };

  const handleRemove = (file) => {
    const updatedList = fileList.filter((item) => item.uid !== file.uid);
    setFileList(updatedList);
    form.setFieldsValue({ [name]: updatedList });
    return true;
  };

  return (
    <Form.Item
      label={label}
      name={name}
      rules={rules}
      valuePropName="fileList"
      getValueFromEvent={(e) => {
        if (Array.isArray(e)) return e;
        return e?.fileList;
      }}
    >
      <Upload
        listType={listType}
        multiple
        beforeUpload={() => false}
        onChange={handleChange}
        onRemove={handleRemove}
        fileList={fileList}
        maxCount={maxCount}
      >
        <Button icon={<UploadOutlined />}>Select Images</Button>
      </Upload>
    </Form.Item>
  );
};

export default FormAntdUploadBase64;
